import AppSettings from "@/modules/app-settings";
import { ApplicationViews, VcsMenuCategory, VcsMenuCategoryPermission } from "@/util/enum";
import { isLinkVisible } from "@/util/func";
import { Paths } from "@/util/paths";
import { Divider, Icon, Layout, Menu, Tooltip } from "ant-design-vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { AppNavigationLocale, ConversationTemplateLocale } from "@/locales/localeid";
import { fmtMsg } from "commonui";
import { RequiredPermissions } from "@/util/constants";
import TitleListState from "@/modules/title-list";

const { Sider } = Layout;
const { Item } = Menu;

export interface AppNavigationRef {
	setParentSelectedMenu: () => void;
}

@Component({
	components: {
		Sider,
		AppMenu: Menu,
		AppMenuItem: Item,
		AppSubMenu: Menu.SubMenu,
		Divider,
		Icon,
		Tooltip
	}
})
export default class AppNavigation extends Vue {
	@Prop() public collapsed!: boolean;
	public appSetting = getModule(AppSettings) as AppSettings;
	public titleListModule = getModule(TitleListState);
	public menuSelectedKeys = [this.appSetting.appMenuSelected];
	public openKeys: number[] = [];
	requiredPermissions = RequiredPermissions;

	@Watch("appSetting.appMenuSelected")
	setParentSelectedMenu() {
		this.menuSelectedKeys = [this.appSetting.appMenuSelected];
	}

	@Watch("appSetting.menuCategory")
	setInitOpenMenu() {
		if (!this.openKeys.length && !this.toggle) {
			this.openKeys = [this.appSetting.menuCategory];
		}
	}

	mounted() {}

	get applicationViews() {
		return ApplicationViews;
	}

	get applicationPaths() {
		return Paths;
	}

	get vcsMenuCategory() {
		return VcsMenuCategory;
	}

	get vcsMenuPermissionCategory() {
		return VcsMenuCategoryPermission;
	}

	get appNavigationLocale() {
		return AppNavigationLocale;
	}

	get templateLocale() {
		return ConversationTemplateLocale;
	}
	get toggle() {
		return this.appSetting.isNavigationCollapsed;
	}

	get getProps() {
		if (this.toggle) {
			return {
				class: "vc-menu vc-menu--toggle",
				mode: "vertical"
			};
		}
		return {
			openKeys: this.openKeys,
			class: "vc-menu",
			mode: "inline"
		};
	}

	localizedString(id: string, params?: {}) {
		return fmtMsg(id, params);
	}

	showLink(menuId: VcsMenuCategory, menuCategoryId?: VcsMenuCategoryPermission) {
		return isLinkVisible(menuId, menuCategoryId);
	}

	// Checks permission depended on the View
	isMenuVisible = (permissions: { menuId: VcsMenuCategory; menuCatId: VcsMenuCategoryPermission }[]) => {
		return permissions.length && permissions.some((e) => this.showAdminLink(e.menuId, e.menuCatId));
	};

	showAdminLink(menuId: VcsMenuCategory, permissionId?: VcsMenuCategoryPermission, superMenuId?: VcsMenuCategory) {
		return isLinkVisible(menuId, permissionId, superMenuId);
	}

	public toggleHandler(): void {
		if (!this.toggle) {
			this.openKeys = [];
			setTimeout(() => {
				this.appSetting.setNavigationCollapse(!this.toggle);
			}, 30);
		} else {
			this.appSetting.setNavigationCollapse(!this.toggle);
			setTimeout(() => (this.openKeys = [this.appSetting.menuCategory]), 50);
		}
	}

	public openChange({ key }) {
		const isAlreadySelected = this.openKeys.indexOf(key);
		if (isAlreadySelected > -1) {
			this.openKeys = [0];
		} else {
			this.openKeys = [key];
		}
	}
	handleMenuClick({ key }) {
		this.appSetting.setChildMenu(key);
	}
	onComponentPageNav(path: string) {
		this.titleListModule.changePersistedData();
		this.$router.push(path).catch(() => {
			console.log("You are still at this route");
		});
	}
}
